<template>
     <el-tooltip v-bind="$attrs"
        v-on="$listeners"
        ref="toolTip"
        effect="dark"
        :content="content"
        :popper-class="iconClass || popperClass"
        :placement="placement">
        <slot slot="content"/>
        <i class="question-icon" :style="`margin: ${margin}`"/>
    </el-tooltip>
</template>

<script>
import { get } from 'lodash'
import { getLen } from '@/utils/index'

export default {
    data() {
        return {
            popperClass: ''
        }
    },

    props: {
        content: {
            type: String,
            default: '这是提示这是提示这是提示'
        },
        iconClass: {
            type: String,
            default: ''
        },
        popperWidth: {
            type: [String, Number]
        },
        margin: {
            type: String,
            default: '0 0 0 4px'
        },
        placement: {
            type: String,
            default: 'top-end'
        }
    },

    mounted() {
        this.$nextTick(() => {
            const popperDom = get(this, '$refs.toolTip.$refs.popper')
            if (popperDom) {
                if (!this.popperWidth) {
                    return popperDom.style.width = getLen(popperDom.innerText, 14) + 'px'
                }
                if (typeof this.popperWidth === 'number') {
                    return popperDom.style.width = this.popperWidth + 'px'
                } else {
                    return popperDom.style.width = this.popperWidth
                }
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.question-icon {
    line-height: 1;
    font-size: 14px;
    color: #fff;
    margin-left: 4px;

    &::before {
        content: '?';
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-weight: normal;
        background: #d0d0d0;
        border-radius: 50%;
    }
}
</style>